import React, { useEffect, useState, useRef } from "react";
import { DatePicker } from 'antd';
import { ErrorMessage } from "@hookform/error-message";
import moment from 'moment-timezone';
import { LabelText, SpanText, SelectBox, Input, Text } from "../../../design";
import { Controller } from "react-hook-form";
import currencyFormatter from "../../../utils/currencyformatter";
import { AmountDivideByHundred } from "../../../helper";
import { normalTextFontSize, smallTextFontSize, quantityTextHeight } from "../../../utils/reseponsive";
import { COUNTRY_PHONE_CODE } from "../../../appconstants";
import NumberFormat from "react-number-format";
import SimpleReactValidator from 'simple-react-validator';
import { isValidPhoneNumber, formatNumber } from 'libphonenumber-js';

type Props = {
  amount: number,
  currencyName: string,
  minQty: number,
  maxQty: number,
  control: any,
  errors: any,
  label: string,
  description: string,
  name: string,
  isPreview: boolean,
  isAdaptive: boolean,
  setValue: any,
  isRequired: boolean,
  comboHide: Function,
  options: any,
  selectedAccount: Function,
  callCombo: Function,
  id: String,
  showComboError: string,
  isComboBoxRequired: Boolean,
}

const dateFormat = 'MM-DD-YYYY';

const InputQuantity = (props: Props) => {
  const { amount, minQty, maxQty, callCombo, isComboBoxRequired, showComboError, currencyName, control, options, label, description, name, isPreview, isAdaptive, setValue, isRequired, comboHide, selectedAccount, id } = props;
  const [inputValue, setInputValue] = useState(isRequired ? (minQty ? minQty : 0) : 0);
  const [defaultAmount, setDefaultAmount] = useState(amount || 0);
  const [minQuantity, setMinQuantity,] = useState(minQty || 0);
  const [maxQuantity, , setMaxQuantity] = useState(maxQty || Number.MAX_SAFE_INTEGER);
  const [phoneFormate, setPhoneFormate] = useState();
  const [phoneNumber, setPhone] = useState('');
  const [countryCode, setCountryCode] = useState('+1');
  const [, forceUpdate] = useState();

  const { gid } = selectedAccount;

  const accGid = [
    "account-ff1166de992e429c82eb02f86dfdbbab",
    "account-ee13cf50fea3429db080b57385445247"
  ];
  const label1 = "Family(2 adults + 2 children)(Non-Member)";
  const label2 = "Family(2 adults + 2 children)(Member)";

  const [comboAddons, setComboAddons] = useState(options);
  const addtionalComboBox = options;

  const updateQuantity = (type) => {
    let updatedInputValue = inputValue;
    if ("ADD" === type) {
      if (updatedInputValue === 0 && minQty > 0) {
        updatedInputValue = minQty;
      } else {
        updatedInputValue += 1;
      }    
      if ((label === label1 || label === label2) && accGid.includes(gid)) {
        if (updatedInputValue > 0) {
          comboHide(false);
        }
      }
      setInputValue(updatedInputValue);
    } else if ("SUB" === type) {
      if (updatedInputValue === minQty) {
        updatedInputValue -= minQty;
      } else {
        updatedInputValue -= 1;
      }      
      if ((label === label1 || label === label2) && accGid.includes(gid)) {
        if (updatedInputValue === 0) {
          comboHide(true);
        }
      }
      setInputValue(updatedInputValue);
    }
  };

  useEffect(() => {
    if (inputValue === 1) {
      setComboAddons(options);
    }
    if (inputValue > 1) {
      let list = [];
      const extItems = JSON.parse(sessionStorage.getItem(`comboboxValidate${id}`));
      if (extItems && extItems.length !== 0) {
        list = extItems.concat(options);
      } else {
        for (let i = 0; i < inputValue; i++) {
          list.push(...options);
        }
      }
      setComboAddons(list);
      callCombo(list, id);
      localStorage.setItem('comboboxAddon', JSON.stringify(list));
      sessionStorage.setItem(`comboboxValidate${id}`, JSON.stringify(list));
      localStorage.setItem('comboboxLength', options.length);
    }
    let updatedAmount = amount || 0;
    if (inputValue > 0) {
      setDefaultAmount(inputValue * updatedAmount);
    } else if (inputValue === 0) {
      setDefaultAmount(amount * 1);
    }
    setValue(`${name}`, inputValue)
  }, [inputValue]);

  useEffect(() => {
    setDefaultAmount(amount);
    if (isRequired) {
      setDefaultAmount(amount * inputValue)
    }
  }, []);

  useEffect(() => {
    let list = [...comboAddons];
    if ((list.length / options.length) > inputValue) {
      list = list.slice(0, -options.length)
      setComboAddons(list);
      callCombo(list, id);
      localStorage.setItem('comboboxAddon', JSON.stringify(list));
      sessionStorage.setItem(`comboboxValidate${id}`, JSON.stringify(list));
      localStorage.setItem('comboboxLength', options.length);
    }
  }, [inputValue])

  // const additionalAddons = () => {
  //   const list = [...comboAddons, ...addtionalComboBox];
  //   setComboAddons(list);
  //   callCombo(list, id);
  //   localStorage.setItem('comboboxAddon', JSON.stringify(list));
  //   localStorage.setItem('comboboxLength', options.length);
  // }

  const updateDob = (date, j) => {
    const Date = moment(date._d).format(dateFormat);
    const list = [...comboAddons];
    const obj = {};
    obj.type = Date;
    obj.price = 0;
    obj.label = list[j].label;
    obj.value = list[j].value;
    obj.acceptText = true;
    list[j] = obj;
    setComboAddons(list);
    callCombo(list, id);
    localStorage.setItem('comboboxAddon', JSON.stringify(list));
    sessionStorage.setItem(`comboboxValidate${id}`, JSON.stringify(list));
    localStorage.setItem('comboboxLength', options.length);
  };

  const onCountryCodeChange = (e, j) => {
    const list = [...comboAddons];
    const obj = {};
    setCountryCode(e);
    const data = formatNumber(`${e}${list[j].phone}`, 'INTERNATIONAL');
    const formater = data.substr(data.indexOf(' ') + 1);
    setPhoneFormate(formater);
    obj.countryCode = e;
    obj.price = 0;
    obj.phone = list[j].phone;
    obj.label = list[j].label;
    obj.value = list[j].value;
    obj.acceptText = true;
    obj.type = `${obj.countryCode}${obj.phone}`;
    list[j] = obj;
    setComboAddons(list);
    callCombo(list, id);
    localStorage.setItem('comboboxAddon', JSON.stringify(list));
    sessionStorage.setItem(`comboboxValidate${id}`, JSON.stringify(list));
    localStorage.setItem('comboboxLength', options.length);
  };

  const onPhoneNumberChange = (e, j) => {
    const list = [...comboAddons];
    const obj = {};
    const updatedPhone = e;
    setPhone(updatedPhone.replace(/[^0-9+]/g, ''));
    setPhoneFormate(updatedPhone.replace(/[^0-9+]/g, ''));
    obj.countryCode = list[j].countryCode ? list[j].countryCode : countryCode;
    obj.price = 0;
    obj.phone = updatedPhone.replace(/[^0-9+]/g, '');
    obj.label = list[j].label;
    obj.value = list[j].value;
    obj.acceptText = true;
    obj.type = `${obj.countryCode}${obj.phone}`;
    list[j] = obj;
    setComboAddons(list);
    callCombo(list, id);
    localStorage.setItem('comboboxAddon', JSON.stringify(list));
    sessionStorage.setItem(`comboboxValidate${id}`, JSON.stringify(list));
    localStorage.setItem('comboboxLength', options.length);
  };

  const updateAcceptText = (e, j) => {
    const list = [...comboAddons];
    const obj = {};
    obj.type = e;
    obj.price = 0;
    obj.label = list[j].label;
    obj.value = list[j].value;
    obj.acceptText = true;
    list[j] = obj;
    setComboAddons(list);
    callCombo(list, id);
    localStorage.setItem('comboboxAddon', JSON.stringify(list));
    sessionStorage.setItem(`comboboxValidate${id}`, JSON.stringify(list));
    localStorage.setItem('comboboxLength', options.length);
  }

  const updateComboValue = (e, j) => {
    const selectedValue = e.target.value;
    const list = [...comboAddons];
    const obj = {};
    obj.type = selectedValue.split("&&")[0];
    obj.price = Number(selectedValue.split("&&")[1]);
    obj.label = list[j].label;
    obj.value = list[j].value;
    obj.children = list[j].children;
    list[j] = obj;
    setComboAddons(list);
    callCombo(list, id);
    localStorage.setItem('comboboxAddon', JSON.stringify(list));
    sessionStorage.setItem(`comboboxValidate${id}`, JSON.stringify(list));
    localStorage.setItem('comboboxLength', options.length);
  }

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      phoneNumValidation: {
        message: 'Enter valid phone number',
        rule: (val, param) => (isValidPhoneNumber(param[0])),
      },
    },
  }));

  const validate = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      console.log(simpleValidator.current.showMessages(), 'simpleValidator.current.showMessages()simpleValidator.current.showMessages()');
      forceUpdate(1);
      return;
    }
  }

  return (
    <div className="my-3">
      <div className="form-group row mb-1 no-gutters d-flex align-items-center">
        <div className="col-sm-5">
          <LabelText fontSize={normalTextFontSize(isPreview, isAdaptive)} color="#0000000"
            hidden={!label} htmlFor="number" className="col-form-label font-weight-bolder m-0 text-break">{label}
            {
              minQty && minQty > 0 ? (
                <SpanText className="pl-2" hidden={isRequired} color="rgba(0, 0, 0, 0.6)"
                  fontSize={smallTextFontSize(isPreview, isAdaptive)}>Min: {minQty}</SpanText>
              ) : (
                <></>
              )
            }
            {
              maxQty && maxQty > 0 ? (
                <SpanText className="pl-2" hidden={isRequired} color="rgba(0, 0, 0, 0.6)"
                  fontSize={smallTextFontSize(isPreview, isAdaptive)}>Max: {maxQty}</SpanText>
              ) : (
                <></>
              )
            }
            
          </LabelText>
        </div>
        <div className="col-sm-7 text-left">
          <div className="input-group d-sm-flex align-items-center justify-content-sm-end">
            <Controller
              defaultValue={inputValue}
              as={
                <>
                  <span className="input-group-prepend">
                    <button type="button" disabled={isRequired ? (inputValue <= 1 || inputValue <= minQuantity) : inputValue <= 0} onClick={() => updateQuantity("SUB")}
                      className="text-center px-1 bg-white rounded-left"
                      style={{
                        width: '25px',
                        border: "solid 0.5px #29b1cc",
                        outline: "none",
                        height: quantityTextHeight(42, isPreview, isAdaptive),
                        fontSize: smallTextFontSize(isPreview, isAdaptive)
                      }}>&#8211;</button>
                  </span>
                  <NumberFormat
                    className="my-0 rounded-0 bg-white text-center"
                    style={{
                      width: "35px",
                      border: "solid 0.5px #29b1cc",
                      outline: "none",
                      height: quantityTextHeight(42, isPreview, isAdaptive),
                      fontSize: smallTextFontSize(isPreview, isAdaptive)
                    }}
                    readOnly
                    onChange={({ target }) => setInputValue(parseInt(target.value))}
                    fixedDecimalScale={false}
                    decimalScale={0}
                    allowNegative={false}
                    allowLeadingZeros={false}
                    value={inputValue}
                  />
                  <span className="input-group-append text-center">
                    <button disabled={inputValue >= maxQuantity} type="button" onClick={() => updateQuantity("ADD")}
                      className="rounded-right text-center px-1 bg-white"
                      style={{
                        width: '25px',
                        border: "solid 0.5px #29b1cc",
                        outline: "none",
                        height: quantityTextHeight(42, isPreview, isAdaptive),
                        fontSize: smallTextFontSize(isPreview, isAdaptive)
                      }}
                    >+</button>
                  </span>
                </>
              }
              name={`${name}`}
              control={control}
            />
            <SpanText fontSize={normalTextFontSize(isPreview, isAdaptive)} className="d-flex pl-2 m-0 align-items-center font-weight-bold">
              {currencyFormatter(AmountDivideByHundred(defaultAmount), currencyName)}</SpanText>
          </div>
        </div>
      </div>
      <div hidden={!description} className="col-sm-10 px-0">
        <LabelText className="text-mute mt-0" fontSize={smallTextFontSize(isPreview, isAdaptive)}>{description}</LabelText>
      </div>
      <div className="form-group row mb-0 no-gutters align-items-center">
        <div className="col-sm-5"></div>
        <div display="flex" className="col-sm-6 mb-2">
          {
            (comboAddons && comboAddons.length > 0) && (
              comboAddons.map((list, j) => (
                <>
                  <LabelText
                    color="#0000000"
                    htmlFor="content"
                    className="col-form-label font-weight-bolder m-0 text-break"
                  >{list.label}
                    <SpanText className="pl-2" hidden={isComboBoxRequired} color="rgba(0, 0, 0, 0.6)"
                      fontSize={smallTextFontSize(isPreview, isAdaptive)}>(Optional)</SpanText>
                  </LabelText>
                  <>
                    {
                      list.acceptText ? (
                        <>
                          {
                            list.label === 'DOB' ? (
                              <DatePicker
                                format={dateFormat}
                                allowClear={false}
                                onChange={(e) => updateDob(e, j)}
                                placeholder="MM-DD-YYYY"
                              />
                            ) : (
                              <>
                                {
                                  list.label === 'Phone' ? (
                                      <>
                                        <SelectBox
                                          style={{
                                            width: '65px',
                                          }}
                                          onChange={(e) => onCountryCodeChange(e, j)}
                                          defaultValue={list.countryCode}
                                        >
                                          {
                                            COUNTRY_PHONE_CODE.map((items) => (
                                              <option key={items} value={items}>
                                                {items}
                                              </option>
                                            ))
                                          }
                                        </SelectBox>
                                        <Input
                                          maxLength={10}
                                          name='Phone number'
                                          onBlur={e => {
                                            if (list.phone) {
                                              setPhone(e.currentTarget.value);
                                              const value = formatNumber(`${list.countryCode}${list.phone}`, 'INTERNATIONAL');
                                              const formater = value.substr(value.indexOf(' ') + 1);
                                              setPhoneFormate(formater);
                                            }
                                          }}
                                          placeholder={list.label}
                                          value={list.phone}
                                          style={{
                                            width: '200px',
                                            height: '36px',
                                            border: '1px solid #C4C4C4',
                                            borderRadius: '6px',
                                          }}
                                          onChange={(e) => onPhoneNumberChange(e.currentTarget.value, j)}
                                        // onBlur={() => setName(name.trim())}
                                        />
                                      </>
                                  ) : (
                                    <>
                                    <Input
                                      placeholder={list.label}
                                      value={list.type || ''}
                                      type={list.label === 'Age' ? 'number' : 'text'}
                                      // maxLength={2}
                                      style={{
                                        width: '265px',
                                        height: '36px',
                                        border: '1px solid #C4C4C4',
                                        borderRadius: '6px',
                                      }}
                                      onChange={(e) => updateAcceptText(e.currentTarget.value, j)}
                                      onBlur={(e) => validate(e)}
                                    />
                                          {
                                            list.label === 'Email' && list.type && (
                                              <Text fontSize={smallTextFontSize(isPreview, isAdaptive)} marginTop="4px" marginBottom="0px" color="#ff1e1e">{simpleValidator.current.message('email', list.type, 'required|email')}</Text>
                                            )
                                          }
                                      
                                    </>
                                  )
                                }
                              </>
                            )
                          }
                        </>
                      ) : (
                        <SelectBox
                          style={{
                            width: '265px',
                          }}
                          onChange={(e) => updateComboValue(e, j)}
                        >
                          {
                            (
                              <option>select</option>)
                          }
                          {
                            list.children.map((items) => (
                              <option key={items.label} value={`${items.value}&&${items.additionalPrice ? items.additionalPrice : 0}`}>
                                {`${items.label}: ${currencyFormatter(AmountDivideByHundred(items.additionalPrice ? items.additionalPrice : 0), currencyName)}`}
                              </option>
                            ))
                          }
                        </SelectBox>
                      )
                    }
                  </>

                </>
              ))
            )
          }
        </div>
      </div>
      {/* {
        (comboAddons.length / options.length) < inputValue && (
          <div className="form-group row mb-0 no-gutters align-items-center">
            <div className="col-sm-5"></div>
            <div display="flex" className="col-sm-6 mb-2">
              <a
                style={{
                  color: '#007bff',
                  cursor: 'pointer',
                }}
                className="ml-2"
                onClick={() => additionalAddons()}
              >
                Add More
              </a>
            </div>
          </div>
        )
      } */}

    </div >
  )
};

export default InputQuantity
